import { Divider } from "@msuite/ui/divider";
import React from "react";
import { IncomingInvoiceFormAmounts } from "./incoming-invoice-form-amounts";
import { IncomingInvoiceFormGeneral } from "./incoming-invoice-form-general";
import { IncomingInvoiceFormIssuer } from "./incoming-invoice-form-issuer";
import { IncomingInvoiceFormPayment } from "./incoming-invoice-form-payment";

/**
 * An incoming invoice's fields, grouped as the pipeline reads them: the invoice itself, its
 * amounts, how it is paid, and who issued it.
 */
export function IncomingInvoiceForm() {
	/** Render */
	return (
		<React.Fragment>
			<IncomingInvoiceFormGeneral />
			<Divider variant="modal" />
			<IncomingInvoiceFormAmounts />
			<Divider variant="modal" />
			<IncomingInvoiceFormPayment />
			<Divider variant="modal" />
			<IncomingInvoiceFormIssuer />
		</React.Fragment>
	);
}
